// import React from 'react'
import React from "react";
import styled from "styled-components";
import { Layout, Menu, Tooltip } from "antd";
import { Link, useLocation } from "react-router-dom";
import Iconmoon from "../../Components/IconsFiles/icon";
import collapse from "../../Assets/Icons/collapse.png";
import expand from "../../Assets/Icons/expand.png";
import { useState } from "react";
import { MenuProps } from 'antd';

const { Sider } = Layout;
const { SubMenu } = Menu;

const SideBarContainer = styled.div`
  .ant-layout-sider-children ul {
    // padding: 0 25px;
    padding: 2px 24px 19px;
    margin: 17px 0px !important;
    li {
      padding: 1px 0px !important;
      border: 0;
      font-family: var(--sf-pro-text);
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      // line-height: 22px;
      // color: #605e5c;
      &:hover {
        color: #ea655b;
      }
      img {
        padding-right: 12px;
      }
    }
  }
  span.anticon.anticon-left {
    background-image: url(${collapse});
    background-size: contain;
    background-repeat: no-repeat;
    width: 20px;
    height: 20px;
    display: inline;
    :after {
      content: "Collapse";
      color: var(--para-text);
      font-family: var(--sf-pro-display-m);
      padding-left: 25px;
      font-style: normal;
      font-size: 14px;
      line-height: 16px;
    }
  }
  span.anticon.anticon-right {
    background-image: url(${expand});
    background-size: contain;
    background-repeat: no-repeat;
    width: 20px;
    height: 20px;
    display: inline;
    :after {
      content: "Expand";
      color: #000;
      font-family: var(--sf-pro-display-m);
      padding-left: 10px;
      font-style: normal;
      font-size: 14px;
      line-height: 16px;
      margin-left: 11px;
    }
  }
  .ant-menu-sub.ant-menu-inline .ant-menu-item{
        line-height:none;
        height: 57px;
  }
  .ant-menu-item::after {
    border: none;
  }
  .ant-menu-item a:hover {
    color: #ea655b;
  }
  .ant-menu-item-selected a{
    color: #ea655b;
  }
  ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light {
    background-color: #faf9f8;
    margin: 17px 0px;
  }
  .ant-menu-item-selected {
    color: #ea655b !important;
    background-color: none;
  }
  .ant-menu-item-selected svg {
    color: #ea655b !important;
  }

  .ant-menu-item-selected a:hover {
    color: #ea655b;
  }
  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: #faf9f8;
  }
  .organization span {
    padding-left: 7px;
    font-family: var(--sf-pro-display-m);
    font-size: 12px;
    line-height: 16px;
    color: var(--para-text);
    text-transform: uppercase;
  }
  .sc-iqseJM.dYhPoH.side-layout {
    margin: 21px !important;
  }
  .ant-layout-sider-children {
    background: #faf9f8;
    width: 275px;
  }
  .ant-layout-sider-has-trigger {
    padding-bottom: 0;
    max-width: 275px !important;
    min-width: 275px !important;
    width: 275px !important;
  }

  .ant-layout-sider {
    background: #faf9f8;
  }
  .ant-layout-sider-children .ant-menu.ant-menu-inline-collapsed {
    background-color: #faf9f8;
    width: 100%;
    margin: 17px auto;
  }
  aside.ant-layout-sider-collapsed {
    .ant-layout-sider-children {
      width: 79px;
      ul {
        li {
          padding: 1px 0px !important;
          // div {
          //   padding-left: 7px,
          //   margin-top: 0px,
          //   margin-bottom: 5px
          // }
        }
      }
    }
    .ant-layout-sider-trigger {
      span {
        &:after {
          opacity: 0;
        }
      }
    }
  }
  svg.IcoSide {
    margin-right: 7px;
  }
  .ant-submenu-item-selected svg {
    color: #ea655b !important;
 }
  .ant-layout-sider-has-trigger {
    flex: 0 0 275px !important;
    max-width: 275px !important;
    min-width: 275px !important;
    width: 275px !important;
    height: 100%;
  }
  .ant-layout-sider-has-trigger.slimslider .ant-layout-sider-trigger {
    width: auto !important;
  }
  .ant-layout-sider-collapsed.ant-layout-sider-has-trigger.slimslider {
    flex: 0 0 80px !important;
    max-width: 80px !important;
    min-width: 80px !important;
    width: 80px !important;
  }
  .ant-menu-inline-collapsed-noicon {
    display: none;
  }
  .ant-layout-sider-collapsed.ant-layout-sider-has-trigger.slimslider
    .ant-layout-sider-trigger {
    width: 80px !important;
  }
 
  .ant-layout-sider-trigger.anticon-right {
    padding-left: 12px;
  }
  .anticon svg {
    display: none;
  }
  .ant-layout-sider-trigger {
    background: #faf9f8;
    padding-left: 32px;
    padding-right: 12px;
    text-align: left;
    bottom: 20px;
    z-index: 12;
  }

  .ant-layout-sider-children {
    position: fixed !important;
    z-index: 10 !important;
  }
  .ant-menu-item:active{
    background: #faf9f8;
  }
 
  .ant-menu-submenu-title:hover {
    color: #ea655b;
  }
  .ant-menu-submenu-title{
    // color: rgb(0 0 0 / 85%);
    // padding: 0px 0px;
    margin-top:-12px;
    margin-bottom: 21px;
    white-space: normal;
    margin-left: -16px;
  }
  .ant-menu-submenu-arrow::before{
    height:0px;
    color:white;
  }
  .ant-menu-submenu-arrow::after{
    height:0px;
    color:white;
  }
  .ant-menu-vertical {
    border: none !important;
  }
  .ant-menu-submenu-popup{
    background-color: black;
    color: white;
    overflow-x: hidden;
    overflow-y: auto;
    // border: none;
  }
  .ant-menu-inline.ant-menu-root .ant-menu-item, .ant-menu-inline.ant-menu-root .ant-menu-submenu-title {
    margin-top: -1px;
    display: flex;
    align-items: center;
    margin-bottom: 6px;
}
  .ant-layout-sider-collapsed {
    &:hover {
      flex: 0 0 250px !important;
      max-width: 250px !important;
      min-width: 250px !important;
      width: 250px !important;
      background-color: black;
    color: white;
    overflow-x: hidden;
    overflow-y: auto;
    // border: none;
    }
  }
  .ant-menu.ant-menu-inline-collapsed .ant-menu-submenu .ant-menu-submenu-title{
    padding-left: 23px;
    margin-top:-2px;
    margin-bottom: 0px;
  }

  .ant-menu .ant-menu-submenu-selected {
      color: #ea655b;
  }
  .ant-menu .ant-menu-submenu:hover{
    color: #ea655b; 
  }
  .ant-menu-submenu .ant-menu-item:hover{
    span {
      color: black; 
    }
  }
  .ant-menu .ant-menu-submenu-selected svg {
    color: #ea655b;
  }
  .ant-menu-submenu .ant-menu-item{
    span{
      color: gray;
    }
  }
  
        .ant-menu-submenu .ant-menu-item-selected{
          span {
            color:  red !important;
            background-color:white;
          }
  }
`;

const Sidebar = ({ headerName = "", listItems = [], is_collapsed = false }) => {
  const [collapsed, setCollapsed] = React.useState(is_collapsed);
  const [currentPage, setCurrentPage] = React.useState("1");
  const [defaultKey, setDefaultKey] = React.useState();
  const [expandedKey, setExpandedKey] = React.useState();
  const [rerender, setRerender] = React.useState(false);
  const [selectedItem , setSelectedItem] = useState( '');
  const location = useLocation();

  React.useEffect(() => {
    listItems.map((item, index) => {
      if(item?.subLinkList && item?.subLinkList?.length){
        item?.subLinkList?.map((childItem, childIndex) => {
          if(location.pathname.includes(childItem.link)){
            changePage(index + 1);
            changeDefualtKey(index + 1);
            setSelectedItem(childItem.label)
          }
        });
      } else{
      if (location.pathname.includes(item.link)) {
        changePage(index + 1);
        changeDefualtKey(index + 1);
      }
    }
    });
  }, [location, listItems]);

  React.useEffect(() => {
    setRerender(true);
}, [defaultKey]);

React.useEffect(() => {
  if (rerender)
    setRerender(false);
}, [rerender]);

const onCollapse = (collapsed) => {
  setCollapsed(collapsed);
  if (collapsed)
    setDefaultKey();
  else
    setDefaultKey(expandedKey);
};

const changePage = (props) => {
  if (collapsed)
    setDefaultKey();
  setCurrentPage(props.toString());
};

const changeSubMenuPage = (props) => {
  setDefaultKey(defaultKey == props.toString() ? "" : props.toString());
  setExpandedKey(defaultKey == props.toString() ? "" : props.toString());
};

const changeDefualtKey = (props) => {
  setDefaultKey(props.toString());
  setExpandedKey(props.toString());
  if (collapsed)
    setDefaultKey();
};

  return ( 
    
    <SideBarContainer className="side-layout">
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={onCollapse}
        className="vBgBlock slimslider"
        style={{ backgroundColor: "#FAF9F8",height: "100vh",          // ADD THIS
          display: "flex",          // ADD THIS
          flexDirection: "column",}}  // ADD THIS }}
        
      >
        <div style={{ overflowY: "auto", flexGrow: 1 }}> {/* ADD THIS WRAPPER */}

        <Menu 
          selectedKeys={[defaultKey]}
          mode="inline"
          openKeys={defaultKey ? [defaultKey.toString()] : []}
          style={{height:'75vh'}}
          >
          <Menu.Item key={0} className="organization">
            {headerName}
          </Menu.Item>
          {listItems.length > 0 &&
            listItems.map((item, index) => (
              item.subLinkList ? (
                  <SubMenu 
                  mode="inline"
                  onTitleClick = {() => changeSubMenuPage(index + 1)}
                  key={(index + 1).toString()}
                  title={
                    <Tooltip placement={collapsed  ? "topRight" : "right"}  title={item.label}>
                    
                    <span>
                      <Iconmoon
                            icon={item.icon}
                            size={16}
                            color="#605E5C"
                            className="IcoSide"
                          />
                        <span>{item.label}</span>
                    </span>
                    </Tooltip>
                  }                  
                  >
                  {item?.subLinkList?.map((childItem, childIndex) => (
                      <Menu.Item 
                      key = {childIndex + 101}
                      onClick={() => {changePage(childIndex + 101); setSelectedItem(childItem.label)}}
                      style={{
                                              display: "flex",
                                              alignItems: "center", // Center items vertically
                                              width: collapsed ? "100%" : "120%",
                                              height: collapsed ? "100%" : "100%",
                                              borderLeft: collapsed 
                                                ? "0px"
                                                : childIndex >= item?.subLinkList?.length - 1 ||
                                                  item?.subLinkList?.length === 1
                                                ? "0px"
                                                : "2px solid #A19F9D",
                                                margin:"0px",
                                                marginTop : childIndex == 0 ? "10px" : '0px',
                                                marginBottom : childIndex ==  item?.subLinkList.length -1 && collapsed ? "10px" : '0px'
                                              // borderBottom: collapsed ? "1px solid #A19F9D" : "",
                                              // backgroundColor: collapsed 
                                              //   ? ProjectId === childItem.projectId
                                              //     ? "rgba(236, 116, 107, 0.1)"
                                              //     : ""
                                              //   : "",
                                            }}
                                          >
                                           
                                            <div
                                              style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                height : 'inherit'
                                              }}
                                            >
                                              {!collapsed ? (
                                               <>
                                               <div
                                                 style={{
                                                   borderLeft: "2px solid #A19F9D",
                                                   height:
                                                     childIndex >= item?.subLinkList?.length - 1 ||
                                                     item?.subLinkList?.length === 1
                                                       ? "22px"
                                                       : "0",
                                                   transform: "translateY(-14px)",
                                                   padding: "0px",
                                                   margin: "0px",
                                                 }}
                                               ></div>
                                               <div
                                                 style={{
                                                   width: "30px",
                                                   height: "25px",
                                                   margin: "0px 3px 20px -12px",
                                                   border: "2px solid #A19F9D",
                                                   borderColor: "transparent transparent #A19F9D",
                                                   borderRadius: "0 30px",
                                                 }}
                                               ></div>
                                             </>
                                              ) : (
                                                <div></div>
                                              )}
                      
                                              {!collapsed ?
                                                <Link to={childItem.link}>
                                                  
                                                  <span
                                                    style={{
                                                      paddingTop: "10px",
                                                      marginLeft: "6px",
                                                     color: selectedItem === childItem.label
                                                                                    ? "rgba(59, 58, 57, 1)"
                                                                                    : "rgba(161, 159, 157, 1)",
                                                           width : '120%',
                                                          
                                                    }}
                                                    
                                                  >
                                                    {childItem.label}
                                                  </span>
                                                </Link>
                                                 : <>
                                                                         <div style={{borderLeft: "2px solid #A19F9D",
                                                                      height: ((childIndex >= item?.subLinkList?.length - 1) || ( item?.subLinkList?.length === 1)) ? "42px" : "42px"}}></div>
                                                                        <div style={{width:"25px", height:"13px", margin:"8px 3px 20px -6px",  
                                                                                    border: "2px solid #A19F9D",
                                                                                    borderColor:"transparent transparent #A19F9D",
                                                                                    borderRadius: "0 110px"}}></div>
                                                                        <div style={{height:"inherit"}}>
                                                                        <Link to={childItem.link} style={{marginTop:"140px"}}>
                                                                              <span style={{paddingTop:"10px", marginLeft:"6px",color:
                                                                                selectedItem === childItem.label
                                                                                    ? "rgba(59, 58, 57, 1)"
                                                                                    : "rgba(161, 159, 157, 1)",}}>
                                                                            {childItem.label}
                                                                            </span>
                                                                        </Link>
                                                                        
                                                                        </div>
                                                                        </>
}
                                              </div>
                      </Menu.Item>
                      )
                  )}
                  </SubMenu>
              ) : (
                <Menu.Item key={index + 1} onClick={() => {changePage(index + 1);setSelectedItem('');}}>
                <Link to={item.link} style={{paddingLeft: "7px"}}>
                  <Iconmoon
                    icon={item.icon}
                    size={16}
                    color="#605E5C"
                    className="IcoSide"
                  />
                  <span>{item.label}</span>
                </Link>
                </Menu.Item>
              )
          ))}
        </Menu>
        </div>
      </Sider>
    </SideBarContainer>
  );
};
export default Sidebar;
